import React, { useCallback, useEffect, useRef } from 'react';

const useResize = (
  elementRef: React.RefObject<HTMLElement>,
): { handleResizeMouseDown: (e: React.MouseEvent) => void } => {
  const handleResizeMouseDown = useCallback(
    (e: React.MouseEvent) => {
      if (!elementRef.current) return;

      const dimensions = elementRef.current.getBoundingClientRect();
      const startX = e.clientX;
      const startY = e.clientY;
      const startWidth = dimensions.width;
      const startHeight = dimensions.height;

      const handleMouseMove = (moveEvent: MouseEvent) => {
        const newWidth = startWidth + moveEvent.clientX - startX;
        const newHeight = startHeight + moveEvent.clientY - startY;
        elementRef.current.style.width = `${newWidth}px`;
        elementRef.current.style.height = `${newHeight}px`;
      };

      const handleMouseUp = () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    },
    [elementRef],
  );

  return { handleResizeMouseDown };
};

export default useResize;
